import WeblabTreatment from "src/model/WeblabTreatment";

export const GET_WEBLAB_START = 'GET_WEBLAB_START';
export const GET_WEBLAB_COMPLETE = 'GET_WEBLAB_COMPLETE';

export interface WeblabTreatmentAction {
    readonly type: string;
}

export interface GetWeblabTreatmentComplete {
    readonly type: string;
    readonly weblabs: WeblabTreatment[];
}

export const setWeblabStart = (): WeblabTreatmentAction => ({
    type: GET_WEBLAB_START
});

export const getWeblabComplete = (weblabs: WeblabTreatment[]): GetWeblabTreatmentComplete => ({
    type: GET_WEBLAB_COMPLETE,
    weblabs: weblabs
});
